import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { BotonDGView } from "./boton";
import { MapaUruz } from "./mapa";
import { SeccionInformativa } from "./seccion";
import { KeaCaptcha } from "app/features/componentes/keacaptcha";
import { KeaMarkdown } from "app/features/componentes/keamarkdown";

export class Nosotros extends React.PureComponent {
    render() {
        return (
            <SeccionInformativa titulo="Nosotros" >
                <div style={{ padding: "20px 0" }} >

                    <div style={{ margin: "1%", padding: "10px", textAlign: "justify", fontFamily: "'Montserrat', sans-serif" }}>
                        URUZ, nace en Los Mochis, Sinaloa. 100% mexicana, iniciamos operaciones en abril del 2018 con la misión de convertirnos en una solución integral para nuestros clientes en sus necesidades de envío y recepción de mercancías, bajo la premisa de tiempos de entrega en 24 y 48 horas, seguridad y calidad en nuestros servicios. Esta misión está respaldada por un equipo de colaboradores comprometidos, tecnología de vanguardia, infraestructura de vehículos nuevos e instalaciones funcionales.
                        <br />
                        <br />
                        La tecnología es nuestra gran aliada, por lo cual desde el inicio contamos con servicios altamente competitivos a través de nuestra página web www.uruz.mx.
                    </div>
                </div>
            </SeccionInformativa>
        )
    }
}

class RowTable extends React.PureComponent<{ titulo: string; texto: string }> {
    render() {
        return (
            <div style={{ marginLeft: "10px" }}>
                <h4>{this.props.titulo} </h4>
                <hr />
                <span style={{ fontSize: "10px", textAlign: "justify" }}>
                    {this.props.texto}
                </span>
            </div>
        )
    }
}

interface PropsItemServicio {
    titulo: string;
    subtitulo: string;
    lista: string[];
    odd?: boolean;
}

class ItemServicio extends React.PureComponent<PropsItemServicio> {
    odd = (x: PropsItemServicio) => x.odd;
    render() {
        const ood = this.odd(this.props);
        const backgroundColor = ood ? "rgba(227,227,227, 1)" : "white";
        return (
            <div style={{ width: "100%", fontFamily: "'Montserrat', sans-serif", backgroundColor: backgroundColor }} >
                <div style={{ paddingLeft: "10px" }}>
                    <h5><strong> {this.props.titulo}</strong> </h5>
                    <p>{this.props.subtitulo}</p>
                    <ul>
                        {
                            this.props.lista.map(x => <li> {x}</li>)
                        }
                    </ul>
                </div>
            </div>
        )
    }
}


export class Servicios extends React.PureComponent {
    render() {
        return (
            <SeccionInformativa titulo="Servicios" >
                <div style={{ padding: "20px 0" }} >

                    <div style={{ flexWrap: "wrap", display: "flex" }}>
                        <ItemServicio
                            titulo=""
                            subtitulo="Ofrecemos tanto envíos de paquetería como de mensajería"
                            lista={[]}
                        />

                        <ItemServicio
                            titulo="TIEMPOS DE ENTREGA"
                            subtitulo="24 y 48 horas a toda nuestra cobertura."
                            lista={[]}
                            odd
                        />

                        <ItemServicio
                            titulo="CONDICIONES DEL SERVICIO"
                            subtitulo="PAGO:"
                            lista={["Pagado en el origen.", "Flete por cobrar."]}
                        />

                        <ItemServicio
                            titulo="ENTREGAS:"
                            subtitulo=""
                            lista={["Ocurre oficina URUZ", "A domicilio."]}
                            odd
                        />

                        <ItemServicio
                            titulo="RECOLECCIÓN A DOMICILIO"
                            subtitulo=""
                            lista={[]}
                        />

                        <ItemServicio
                            titulo=""
                            subtitulo="ACUSE DE RECIBO"
                            lista={["De empresa e Interno"]}
                            odd
                        />

                        <ItemServicio
                            titulo="SEGURO"
                            subtitulo="Por solo $8.00 por cada mil del valor de tu envío asegura tu mercancía contra cualquier imprevisto en el transporte y protege tu patrimonio."
                            lista={[]}
                        />

                        <ItemServicio
                            titulo="SERVICIOS ELECTRÓNICOS"
                            subtitulo="Visita nuestra página www.uruz.mx y accede a los siguientes servicios:"
                            lista={[]}
                            odd
                        />

                        <ItemServicio
                            titulo="RASTREO"
                            subtitulo="Consulta el estatus de tu envío, desde la documentación hasta la entrega con solo capturar el número de guía."
                            lista={[]}
                            odd
                        />

                        <ItemServicio
                            titulo="INFORMACIÓN DE ENVÍOS"
                            subtitulo="Solicita tu código de usuario y tu contraseña para consultar los siguientes reportes:"
                            lista={["Guías enviadas y su estatus actual.", "Guías recibidas en nuestro almacén y en proceso de entrega.", "Estatus de tu crédito."]}
                            odd
                        />

                        <ItemServicio
                            titulo="PRUEBA DE ENTREGA CON FIRMA ELECTRÓNICA"
                            subtitulo=""
                            lista={[]}
                            odd
                        />

                        <ItemServicio
                            titulo="COTIZADOR"
                            subtitulo=""
                            lista={["Captura el código postal origen y destino.", "Captura el largo por ancho por alto de tu caja y el peso real.", "Indica los servicios que quieres agregar.", "Obtén tu cotización de envío."]}
                            odd
                        />

                        <ItemServicio
                            titulo="URUZ EN TU EMPRESA"
                            subtitulo="Documenta todos tus envíos desde tu empresa y obtén:"
                            lista={["Tarifa diferenciada.", "Todos tus paquetes salen identificados (etiquetados) desde tu almacén.", "Desde el momento de documentar tu cliente conocela referencia con que recibirá sus paquetes."]}
                        />

                        <ItemServicio
                            titulo=""
                            subtitulo="Requisitos:"
                            lista={["Volumen de envíos.", "Presentar documentación para abrir una línea de crédito.", "Cualquier dispositivo móvil.", "Impresora."]}
                        />
                    </div>
                </div>
            </SeccionInformativa>
        )
    }
}

export class Cobertura extends React.PureComponent {
    render() {
        return (
            <SeccionInformativa titulo="Cobertura" >
                <div style={{ padding: "20px 0" }} >
                    <div style={{ margin: "1%", padding: "10px" }} >
                        <MapaUruz />
                    </div>
                </div>
            </SeccionInformativa>
        )
    }
}

interface PropsItemSucursal {
    titulo?: string;
    direccion: string;
    telefono1?: string;
    telefono2?: string;
    telefono3?: string;
}

class ItemSucursal extends React.PureComponent<PropsItemSucursal> {
    tieneTitulo = (x: PropsItemSucursal) => x.titulo != undefined;

    render() {
        const tieneTitulo = this.tieneTitulo(this.props);
        return (
            <div style={{ width: '31%', margin: "1%", padding: "10px", fontFamily: "'Montserrat', sans-serif" }} >
                {
                    tieneTitulo &&
                    <div>
                        <h4><strong> {this.props.titulo}</strong>  </h4>
                        <hr />
                    </div>
                }
                <span style={{ fontSize: "12px", textAlign: "justify", fontFamily: "'Montserrat', sans-serif" }}>
                    {this.props.direccion}
                    <br />
                    <br />
                    <div style={{ fontSize: "12px", fontFamily: "'Montserrat', sans-serif" }} >
                        <i style={{ fontSize: "16px" }} className={fa("phone")} >  </i>  Teléfono: <br />
                        {this.props.telefono1}<br />{this.props.telefono2}<br />{this.props.telefono3}
                    </div>
                </span>
            </div>
        )
    }
}

export class Sucursales extends React.PureComponent {
    render() {
        return (
            <div>
                <SeccionInformativa titulo="Sucursales" >
                    <div style={{ padding: "20px 0" }} >
                        <div style={{ flexWrap: "wrap", display: "flex" }}>
                            <ItemSucursal
                                titulo="Monterrey"
                                direccion="Centro de Distribución Plaza Jumbo, Bodega #10, Av. Churubusco y Francisco Beltrán, 64540 Monterrey, N.L."
                                telefono1="(81) 8331 7292"
                                telefono2="(81) 8331 8327"
                                telefono3="(81) 8351 5439"
                            />

                            <ItemSucursal
                                titulo="Guadalajara"
                                direccion="Calle 3 #1374, Bodega 4, Col. Colón Industrial, CP 44940, Guadalajara, Jalisco, Mx."
                                telefono1="(33) 3619 0989"
                                telefono2="(33) 3619 4387"
                                telefono3="(33) 3619 8267"
                            />

                            <ItemSucursal
                                titulo="Tepic"
                                direccion="Calle Teikame #21-A, Col. Mercado Nayarabastos, CP. 63173, Tepic, Nayarit, Mx."                              telefono1="(311) 133 7109"
                                telefono2="(311) 133 7112"
                                telefono3="(311) 133 7121"
                            />

                            <ItemSucursal
                                titulo="Mazatlán"
                                direccion="Carretera Internacional al norte Km 1.5, Col. El Venadillo, CP 82129, Mazatlán, Sinaloa, Mx."
                                telefono1="(669) 1 35 2250"
                                telefono2="(669) 1 35 2251"
                                telefono3="(669) 1 35 2252"
                            />

                            <ItemSucursal
                                titulo="Culiacán"
                                direccion="Industrias del Valle No. 2869 (Parque Industrial CANACINTRA 2). Col. San Rafael, CP. 80150 Culiacán, Sinaloa, Mx."
                                telefono1="(667) 766 3187"
                                telefono2="(667) 766 3188"
                                telefono3="(667) 766 3207"
                            />

                            <ItemSucursal
                                titulo="Los Mochis"
                                direccion="Centro de logística y distribución integral (LDI) locales C27-28, carretera México 15, CP. 81254 Los Mochis, Sinaloa, Mx."
                                telefono1="(668) 819 8122"
                                telefono2="(668) 819 8123"
                                telefono3="(668) 819 8127"
                            />

                            <ItemSucursal
                                titulo="Navojoa"
                                direccion="Sufragio Efectivo No. 230 Reforma, CP. 85830 Navojoa, Sonora, Mx."
                                telefono1="(642) 422 5958"
                                telefono2="(642) 422 9881"
                                telefono3="(642) 422 8173"
                            />

                            <ItemSucursal
                                titulo="Ciudad Obregón"
                                direccion="Jalisco No. 816-4 entre norte y cajeme. Col. Centro, CP. 85000 Cd. Obregón, Sonora, Mx."
                                telefono1="(644) 4158 903"
                                telefono2="(644) 4156 569"
                                telefono3="(644) 4157 230"
                            />
                            <ItemSucursal
                                titulo="Guaymas"
                                direccion="Calle Naranjo esquina con Calle Jaiba, S/N, Bodega 4, Colonia Guadalupe, Código postal 85440, Guaymas, Sonora, Mx."
                                telefono1="(622) 222 5983"
                                telefono2="(622) 222 6418"
                                telefono3="(622) 222 6496"
                            />

                            <ItemSucursal
                                titulo="Hermosillo"
                                direccion="Ave. José Ma. Mendoza No. 101 Col. El Llano, CP. 83214 Hermosillo, Sonora, Mx."
                                telefono1="(662) 261 5150"
                                telefono2="(662) 261 5624"
                            />
                            <ItemSucursal
                                titulo="Nogales"
                                direccion="Retorno Libre Comercio Boulevard de Los Negocios, 12-A, Polígono P, Colonia Parque Industrial Nogales, Código Postal 84094 Nogales, Sonora, Mx."
                                telefono1="(631) 3193798"
                            />

                            <ItemSucursal
                                titulo="Caborca"
                                direccion="Calle Obregón No. 271 entre R y S Col. Centro CP. 83640 Caborca, Sonora, Mx."
                                telefono1="(637) 3725683"
                            />

                            <ItemSucursal
                                titulo="Magdalena de kino"
                                direccion="Av. Niños Héroes 107  Col. Centro, CP 84160, 
                                Magdalena De Kino, Sonora, Mx. "
                                telefono1="(632) 3227010"
                            />
 
                            <ItemSucursal
                                titulo="León"
                                direccion="Calle Torquito #103, Col. Plaza de toros, León, Guanajuato, CP 37457"
                                telefono1="(477) 1011596"
                            />
                            
                            <ItemSucursal
                                titulo="Guasave"
                                direccion= "Av. Insurgentes s/n, esquina con Lázaro Cárdenas, Col. del Bosque, Guasave, Sinaloa, CP: 81040"
                                telefono1= "(687) 3000701"
                            />

                            <ItemSucursal
                                titulo="Aguascalientes"
                                direccion="Block C - bodega 25, Central de Abastos, CP 20280, Aguascalientes, Aguascalientes, Mx."
                                telefono1="(66) 8172 7624"
                            />

                            <ItemSucursal
                                titulo="Punto de venta Los Mochis"
                                direccion="Juan Aldama No. 238 sur, Col. Centro, Los Mochis, Sinaloa, Mx."
                                telefono1="(668) 819 8127"
                            />
                        </div>
                    </div>

                </SeccionInformativa>

                <SeccionInformativa titulo="Corporativo" >
                    <div style={{ padding: "20px 0" }} >
                        <div style={{ flexWrap: "wrap", display: "flex" }}>
                            <ItemSucursal
                                direccion="I. Allende No. 1899 Nte., Fracc. Las FuentesCP. 81223, Los Mochis, Sinaloa, Mx."
                                telefono1="(668) 817 5656"
                                telefono2="(668) 817 0486"
                                telefono3="(668) 817 1653"
                            />
                        </div>
                    </div>
                </SeccionInformativa>
            </div>
        )
    }
}




interface StateContacto {
    value: models.CorreoContactoDatos;
}

export class Contacto extends React.PureComponent<{}, StateContacto> {
    modalManager = kea.createModalManager();
    constructor(props) {
        super(props);
        this.state = { value: this.valueInicial };
    }

    valueInicial = { Nombre: "", Correo: "", Telefono: "", Empresa: "", Comentario: "" } as models.CorreoContactoDatos;

    value = (state: StateContacto) => state.value;
    onChange = (value: models.CorreoContactoDatos) => new Promise<void>(resolve => this.setState({ value: value }, resolve));
    onEnviar = async () => {
        const value = this.state.value;
        var res = await resources.CorreoContacto.EnviarCorreoContacto(value);
        this.setState({ value: this.valueInicial });
        await kea.message("Mensaje enviado");
    }

    render() {
        const value = this.value(this.state);
        return (
            <ContactoComp value={value} onChange={this.onChange} onEnviar={this.onEnviar} />
        )
    }
}

interface PropsContacto {
    titulo: string;
    value: string;
    onChange: (x: string) => void
    multi?: boolean;
    obl?: boolean;
}

class ItemContacto extends React.PureComponent<PropsContacto> {

    value = (x: PropsContacto) => x.value;
    render() {
        const value = this.value(this.props);
        return (
            <div style={{ width: '100%', margin: "1%", padding: "5px", flexWrap: "wrap", display: "flex", direction: "initial" }} >
                <div style={{ width: '30%', maxHeight: "30px", padding: "5px", backgroundColor: "rgba(245, 102, 0, 1)", fontSize: 18, textAlign: "center", fontFamily: "'Montserrat', sans-serif", color: "white", fontWeight: "bold" }} >
                    {this.props.titulo}
                </div>
                <div style={{ marginLeft: "1%", width: '65%', fontSize: 18, textAlign: "center", fontFamily: "'Montserrat', sans-serif" }} >
                    <kea.Text value={this.props.value} onChange={x => this.props.onChange(x)} multiline={this.props.multi} />
                </div>
                <div style={{ marginLeft: "1%", width: '2%', fontSize: 25, color: "red", textAlign: "center", fontFamily: "'Montserrat', sans-serif" }} >
                    {(this.props.obl && !value) ? "*" : ""}
                </div>
            </div>
        )
    }
}

interface ContactoCompProps {
    value: models.CorreoContactoDatos;
    onChange: (x: models.CorreoContactoDatos) => void;
    onEnviar: () => void;
}

export function validarContacto(x: models.CorreoContactoDatos) {
    const rules: validation.Rules<models.CorreoContactoDatos> = {
        Comentario: validation.required,
        Correo: validation.required,
        Empresa: validation.required,
        Nombre: validation.required,
        Telefono: validation.required
    };
    return validation.getErrors(rules, x);
}

class ContactoComp extends React.PureComponent<ContactoCompProps, { leido: boolean, captcha: boolean, func: () => void }> {
    constructor(props) {
        super(props);
        this.state = { leido: false, captcha: false, func: () => { } };
    }

    value = (x: ContactoCompProps) => x.value;
    errors = createSelectorRx(this.value, x => validarContacto(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));


    onHandleLeido = async (event: React.FormEvent<HTMLInputElement>) => {
        this.setState({ leido: event.currentTarget.checked })
    }

    onSuccess = async (reset: () => void) => {
        await this.setState({ captcha: true, func: reset })
    }

    onExpired = async () => {
        await this.setState({ captcha: false });
    }

    onEnviar = async () => {
        const value = this.props.value;

        if (value.Nombre == "" || value.Nombre == undefined) {
            await kea.message("Error", "Campo Nombre es obligatorio", "error");
            return;
        }

        if (value.Telefono == "" || value.Telefono == undefined) {
            await kea.message("Error", "Campo Teléfono es obligatorio", "error");
            return;
        }

        if (value.Correo == "" || value.Correo == undefined) {
            await kea.message("Error", "Campo Correo es obligatorio", "error");
            return;
        }

        if (value.Comentario == "" || value.Comentario == undefined) {
            await kea.message("Error", "Campo Comentario es obligatorio", "error");
            return;
        }

        //Por el momento Uruz no cuenta con aviso de privacidad, por ahora no se validará
        // if (!this.state.leido) {
        //     await kea.message("Error", "Debe aceptar el aviso de privacidad", "error");
        //     return;
        // }

        if (!this.state.captcha) {
            await kea.message("Error", "Debe completar el captcha", "error");
            return;
        }
        await this.props.onEnviar();
        this.state.func();
        this.setState({ leido: false, captcha: false })
    }

    render() {
        const value = this.value(this.props);
        const getField = this.getField;
        const hasError = this.hasError(this.props);
        const Text = getField(ItemContacto);

        return (
            <SeccionInformativa titulo="Contacto" >
                <div style={{ padding: "20px 0" }} >
                    <div style={{ flexWrap: "wrap", display: "flex", direction: "initial" }}>
                        <Text field="Nombre" titulo="Nombre" obl />
                        <Text field="Telefono" titulo="Teléfono" obl />
                        <Text field="Correo" titulo="Correo" obl />
                        <Text field="Empresa" titulo="Empresa" />
                        <Text field="Comentario" titulo="Comentario" obl multi />

                        <div style={{ width: '100%', margin: "1%", padding: "5px", flexWrap: "wrap", display: "flex", direction: "initial" }} >
                            <div style={{ width: '30%', maxHeight: "30px", padding: "5px" }} >
                            </div>
                            <div style={{ marginLeft: "1%", width: '65%', fontSize: 18, color: "red", fontFamily: "'Montserrat', sans-serif", fontWeight: "bold" }} >
                                Campos obligatorios: *
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{ width: '100%', flexWrap: "wrap", display: "flex", direction: "initial" }} >

                    <div style={{ width: '30%' }} >
                    </div>

                    <div style={{ marginLeft: "1%", width: '68%', fontFamily: "'Montserrat', sans-serif", fontSize: "18px" }} >
                        <span>
                            {/* 
                            Por el momento Uruz no cuenta con aviso de privacidad, por ahora no se mostrará
                            <input
                                type="checkbox"
                                checked={this.state.leido || false}
                                onChange={this.onHandleLeido} />
                            {' '}
                            He leido el <kea.Link children="Aviso de privacidad" style="danger" /> */}
                            {' '}
                            <KeaCaptcha
                                tema="light"
                                tipo="image"
                                sitekey="6LcHPmkUAAAAAEdQjm67iFa6u-j6vOiB2vsXATsZ"
                                onSuccess={this.onSuccess}
                                onExpired={this.onExpired}
                            />
                        </span>
                    </div>

                    <br />
                    <br />
                    <br />

                    <div style={{ width: '30%' }} >
                    </div>
                    <div style={{ marginLeft: "1%", width: '68%' }} >
                        <div style={{ width: '100%', flexWrap: "wrap", display: "flex", direction: "initial" }} >

                            <kea.IconButton onClick={this.onEnviar} block >
                                <BotonDGView
                                    style="pressed"
                                    text="Envíar"
                                    width="90px"
                                    height="34px"
                                    disableMargin
                                />
                            </kea.IconButton>
                        </div>
                    </div>
                </div>
            </SeccionInformativa >
        )
    }
}

export class AvisoPrivacidad extends React.PureComponent {

    private onDescagar = async () => {
        if (await kea.yesno("¿Descargar el aviso de privacidad?")) {
            const aviso = await resources.ConfigSistema.GetAviso();
            kea.download(kea.base64ToBlob(aviso, 'application/pdf'), "AVISO DE PRIVACIDAD.pdf");
        }
    }

    render() {
        return (
            <SeccionInformativa titulo="AVISO DE PRIVACIDAD" >
                <div style={{ padding: "20px 0" }} >
                    <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                        <kea.Link children="Descargar" iconClass={fa("file-pdf-o")} style="primary" onClick={this.onDescagar} />
                    </div>

                    <div style={{ margin: "1%", padding: "10px", textAlign: "justify", fontFamily: "'Montserrat', sans-serif" }}>
                        <p>
                            URUZ Servicios Inteligentes de Logística S.A. De C.V., mejor conocido como URUZ Servicios Inteligentes de Logística, con domicilio en calle IGNACIO ALLENDE NO. 1899 NTE., colonia FRACCIONAMIENTO LAS FUENTES, ciudad LOS MOCHIS, municipio o delegación AHOME, c.p. 81223, en la entidad de SINALOA, país México, y portal de internet WWW.URUZ.MX, es el responsable del uso y protección de sus datos personales, y al respecto le informamos lo siguiente:
                        </p>
                        <br />
                        <br />
                        <h5><strong> ¿Para qué fines utilizaremos sus datos personales?</strong> </h5>
                        <br />
                        <br />
                        <p>
                            Los datos personales que recabamos de usted, los utilizaremos para las siguientes finalidades que son necesarias para el servicio que solicita:
                        </p>
                        <br />
                        <ul>
                            <li>Para operar y administrar los servicios logísticos que contrata con nosotros.</li>
                            <li>Para verificar y confirmar su identidad y situación crediticia con nosotros.</li>
                        </ul>
                        <br />
                        <br />
                        <p>
                            De manera adicional, utilizaremos su información personal para las siguientes finalidades secundarias que <strong>no son necesarias</strong> para el servicio solicitado, pero que nos permiten y facilitan brindarle una mejor atención:
                        </p>
                        <br />
                        <ul>
                            <li>Mercadotecnia o publicitaria</li>
                            <li>Prospección comercial</li>
                        </ul>
                        <br />
                        <br />
                        <p>
                            En caso de que no desee que sus datos personales se utilicen para estos fines secundarios, indíquelo a continuación:
                        </p>
                        <br />
                        <br />
                        <p>
                            No consiento que mis datos personales se utilicen para los siguientes fines:
                        </p>
                        <br />
                        <ul style={{ listStyleType: "none" }} >
                            <li>[ ] Mercadotecnia o publicitaria</li>
                            <li>[ ] Prospección comercial</li>
                        </ul>
                        <br />
                        <br />
                        <br />
                        <p>
                            La negativa para el uso de sus datos personales para estas finalidades no podrá ser un motivo para que le neguemos los servicios y productos que solicita o contrata con nosotros.
                        </p>
                        <br />
                        <br />
                        <h5><strong>¿Qué datos personales utilizaremos para estos fines?</strong> </h5>
                        <br />
                        <br />
                        <p>
                            Para llevar a cabo las finalidades descritas en el presente aviso de privacidad, utilizaremos los siguientes datos personales:
                        </p>
                        <br />
                        <ul >
                            <li>Datos de identificación</li>
                            <li>Datos de contacto</li>
                            <li>Datos patrimoniales y/o financieros</li>
                        </ul>
                        <br />
                        <br />
                        <h5><strong>¿Cómo puede acceder, rectificar o cancelar sus datos personales, u oponerse a su uso?</strong> </h5>
                        <br />
                        <br />
                        <p>
                            Usted tiene derecho a conocer qué datos personales tenemos de usted, para qué los utilizamos y las condiciones del uso que les damos (Acceso). Asimismo, es su derecho solicitar la corrección de su información personal en caso de que esté desactualizada, sea inexacta o incompleta (Rectificación); que la eliminemos de nuestros registros o bases de datos cuando considere que la misma no está siendo utilizada adecuadamente (Cancelación); así como oponerse al uso de sus datos personales para fines específicos (Oposición). Estos derechos se conocen como derechos ARCO.
                        </p>
                        <br />
                        <br />
                        <p>
                            Para el ejercicio de cualquiera de los derechos ARCO, usted deberá presentar la solicitud respectiva a través del siguiente medio:
                        </p>
                        <br />
                        <br />
                        <p>
                            Enviando correo electrónico a contacto@uruz.mx
                        </p>
                        <br />
                        <br />
                        <p>
                            Para conocer el procedimiento y requisitos para el ejercicio de los derechos ARCO, ponemos a su disposición el siguiente medio:
                        </p>
                        <br />
                        <br />
                        <p>
                            Enviando un correo a contacto@uruz.mx
                        </p>
                        <br />
                        <br />
                        <p>
                            Los datos de contacto de la persona o departamento de datos personales, que está a cargo de dar trámite a las solicitudes de derechos ARCO, son los siguientes:
                        </p>
                        <br />
                        <ol type="a">
                            <li>Nombre de la persona o departamento de datos personales: Ana Cristina Vega Lugo</li>
                            <li>Domicilio: calle IGNACIO ALLENDE NO. 1899 NTE, colonia FRACCIONAMIENTO LAS FUENTES, ciudad LOS MOCHIS, municipio o delegación AHOME, c.p. 81223, en la entidad de SINALOA, país México</li>
                            <li>Correo electrónico: rh@uruz.mx</li>
                            <li>Número telefónico: 01 (668) 8 12 90 65</li>
                        </ol>
                        <br />
                        <br />
                        <h5><strong>Usted puede revocar su consentimiento para el uso de sus datos personales</strong> </h5>
                        <br />
                        <br />
                        <p>
                            Usted puede revocar el consentimiento que, en su caso, nos haya otorgado para el tratamiento de sus datos personales. Sin embargo, es importante que tenga en cuenta que no en todos los casos podremos atender su solicitud o concluir el uso de forma inmediata, ya que es posible que por alguna obligación legal requiramos seguir tratando sus datos personales. Asimismo, usted deberá considerar que para ciertos fines, la revocación de su consentimiento implicará que no le podamos seguir prestando el servicio que nos solicitó, o la conclusión de su relación con nosotros.
                        </p>
                        <br />
                        <br />
                        <p>
                            Para revocar su consentimiento deberá presentar su solicitud a través del siguiente medio:
                        </p>
                        <br />
                        <br />
                        <p>
                            Enviando correo electrónico a contacto@uruz.mx
                        </p>
                        <br />
                        <br />
                        <p>
                            Para conocer el procedimiento y requisitos para la revocación del consentimiento, ponemos a su disposición el siguiente medio:
                        </p>
                        <br />
                        <br />
                        <p>
                            Enviando correo electrónico a contacto@uruz.mx
                        </p>
                        <br />
                        <br />
                        <h5><strong>¿Cómo puede limitar el uso o divulgación de su información personal?</strong> </h5>
                        <br />
                        <br />
                        <p>
                            Con objeto de que usted pueda limitar el uso y divulgación de su información personal, le ofrecemos los siguientes medios:
                        </p>
                        <br />
                        <br />
                        <p>
                            Enviando correo electrónico a contacto@uruz.mx
                        </p>
                        <br />
                        <br />
                        <p>
                            Asimismo, usted se podrá inscribir a los siguientes registros, en caso de que no desee obtener publicidad de nuestra parte:

                        </p>
                        <br />
                        <br />
                        <p>
                            Registro Público para Evitar Publicidad, para mayor información consulte el portal de internet de la PROFECO <br />Registro Público de Usuarios, para mayor información consulte el portal de internet de la CONDUSEF
                        </p>
                        <br />
                        <br />
                        <h5><strong>El uso de tecnologías de rastreo en nuestro portal de internet</strong> </h5>
                        <br />
                        <br />
                        <br />
                        <p>
                            Le informamos que en nuestra página de internet utilizamos cookies, web beacons u otras tecnologías, a través de las cuales es posible monitorear su comportamiento como usuario de internet, así como brindarle un mejor servicio y experiencia al navegar en nuestra página. Los datos personales que recabamos a través de estas tecnologías, los utilizaremos para los siguientes fines:
                        </p>
                        <br />
                        <br />
                        <p>
                            Para identificación de usuario, contraseña e información como cliente
                        </p>
                        <br />
                        <br />
                        <p>
                            Los datos personales que obtenemos de estas tecnologías de rastreo son los siguientes:
                        </p>
                        <br />
                        <ul style={{ listStyleType: "none" }}>
                            <li>Identificadores, nombre de usuario y contraseñas de una sesión</li>
                            <li>Región en la que se encuentra el usuario</li>
                            <li>Tipo de navegador del usuario</li>
                            <li>Fecha y hora del inicio y final de una sesión de un usuario</li>
                            <li>Publicidad revisada por un usuario</li>
                        </ul>
                        <br />
                        <br />
                        <h5><strong>¿Cómo puede conocer los cambios en este aviso de privacidad?</strong> </h5>
                        <br />
                        <br />
                        <p>
                            El presente aviso de privacidad puede sufrir modificaciones, cambios o actualizaciones derivadas de nuevos requerimientos legales; de nuestras propias necesidades por los productos o servicios que ofrecemos; de nuestras prácticas de privacidad; de cambios en nuestro modelo de negocio, o por otras causas.
                        </p>
                        <br />
                        <br />
                        <p>
                            Nos comprometemos a mantenerlo informado sobre los cambios que pueda sufrir el presente aviso de privacidad, a través de: Nuestra página web www.uruz.mx.
                        </p>
                        <br />
                        <br />
                        <p>
                            El procedimiento a través del cual se llevarán a cabo las notificaciones sobre cambios o actualizaciones al presente aviso de privacidad es el siguiente:
                        </p>
                        <br />
                        <br />
                        <p>
                            Nuestra página web www.uruz.mx
                        </p>
                    </div>
                </div>
            </SeccionInformativa>
        )
    }
}

interface AvisoProps {
    puedeModificar: boolean;
    avisoConfig: string;
}
interface AvisoState {
    value: Promise<string> | string
}

class AvisoPrivacidadAux extends React.PureComponent<AvisoProps, AvisoState> {
    constructor(props) {
        super(props);
        this.state = { value: props.avisoConfig };
    }

    puedeModificar = (x: AvisoProps) => x.puedeModificar;

    private onDescagar = async () => {
        if (await kea.yesno("¿Descargar el aviso de privacidad?")) {
            const aviso = await resources.ConfigSistema.GetAviso();
            kea.download(kea.base64ToBlob(aviso, 'application/pdf'), "AVISO DE PRIVACIDAD.pdf");
        }
    }

    private onGuardar = async () => {
        const config = await resources.ConfigSistema.Get();
        const value = await this.state.value;
        await resources.ConfigSistema.Update({ ...config, AvisoPrivacidadTexto: value })
    }

    onChange = (value: string) => new Promise<void>(resolve => this.setState({ value: value }, resolve));

    render() {
        const puedeModificar = this.puedeModificar(this.props);
        return (
            <SeccionInformativa titulo="AVISO DE PRIVACIDAD" >
                <div style={{ padding: "20px 0" }} >
                    <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                        <kea.Link children="Descargar" iconClass={fa("file-pdf-o")} style="primary" onClick={this.onDescagar} />
                    </div>

                    <div style={{ margin: "1%", padding: "10px", textAlign: "justify", fontFamily: "'Montserrat', sans-serif" }}>
                        <KeaMarkdown value={this.state.value} onChange={this.onChange} puedeModificar={puedeModificar} onGuardar={this.onGuardar} />
                    </div>
                </div>
            </SeccionInformativa>
        )
    }
}

const AvisoPrivacidadAuxRx = componentToRx(AvisoPrivacidadAux);

export class AvisoPrivacidad2 extends React.PureComponent {
    permisos = () => resources.User.PermisoRx;
    puedeModificar = createSelectorRx(this.permisos, permisos => permisos.Configuraciones.PuedeModificarAvisoPrivacidad);
    aviso = observeResource(resources.ConfigSistema.GetAvisoMarkdown);
    render() {
        const puedeModificar = this.puedeModificar(this);
        return (
            <AvisoPrivacidadAuxRx
                puedeModificar={puedeModificar}
                avisoConfig={this.aviso}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/diseño/items/secciones.tsx